<template>
	<div class="resources">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar back />
		</div><!-- header -->
		<div class="header-image red"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<SectionTitle
				icon="TagIcon"
				subtitle="Category"
				:title="$route.params.id"
				colour="red"
			/>
			<div class="section-gap section-ports">
				<div class="section-title-wrap">
					<h2 class="section-title">{{ count }} Resource{{ count > 1 ? 's' : '' }}</h2>
				</div>
				<div class="card-row-wrap">
					<CardRow
                        v-for="resource in resources"
                        :key="resource.id"
						routeName="ResourcesSingle"
                        :id="resource.id"
						class="card-row-block-resources"
						:title="resource.title"
						:tag="resource.category"
						:type="resource.simplified_type"
					/>
				</div><!-- port card wrap -->
			</div>
		</div>
		<ResourceSearchOverlay />
		<ResourceAdviceOverlay />
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import CardRow from '@/components/CardRow.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
	import ResourceSearchOverlay from '@/components/ResourceSearchOverlay.vue';
	import ResourceAdviceOverlay from '@/components/ResourceAdviceOverlay.vue';
    import ResourceService from '@/services/ResourceService';
	export default {
		name: 'ResourcesMediaType',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			CardRow,
			SectionTitle,
			ResourceSearchOverlay,
			ResourceAdviceOverlay
		},
		data () {
	        return {
                count: 0,
                resources: []
	        };
	    },
	    methods: {
            getCategoryResources () {
                ResourceService.getCategoryResources(this.$route.params.id).then((response) => {
                    this.count = response.data.count;
                    // Sort resources by date (newest first)
                    this.resources = response.data.resources.sort((a, b) => {
                        return new Date(b.created_at || b.date || 0) - new Date(a.created_at || a.date || 0);
                    });
                });
            }
        },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        }
		},
		mounted () {
            this.getCategoryResources();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	.section-title {
		color: $grey;
	}
</style>
